<template>
    <ul class="txtContent">
      <li v-for="(type,index) in sortTags"
          :key="index"
          :class="[(!isPic(type.standardData)&&type.standardData&&type.standardData.length>36)?'fill':'','fl']">
        <span class="attribute-l fl">{{type.standardName}}：</span>
        <span class="attribute-r fl"
              v-if="type.standardData"
              style="word-break:break-all">
          <a href="javascript:;"
              class="upload-pic"
              @click="caozuoFunc(type.standardData,'img')"
              v-if="isPic(type.standardData)">
            <img class="label-preview"
                  :src="type.standardData">
          </a>
          <a href="javascript:;"
              class="upload-pic"
              @click="caozuoFunc(type.standardData,'video')"
              v-else-if="isVideo(type.standardData)">
            <video :src="type.standardData" webkit-playsinline="true"
         playsinline="true" @click.stop=""></video>
          </a>
          <span href="javascript:;" class="upload-pic" v-else-if="type.standardData.indexOf('http')==-1">
            {{type.standardData}}
          </span>
          <a href="javascript:;"
              class="upload-pic"
              style="display:flex;"
              v-else
              @click="caozuoFunc(type.standardData,'file')">
            <div>
              <img v-if="type.standardData.indexOf('xlsx')>-1"
                    class="label-preview"
                    :src="require('../../assets/image/images/icons/icon_file_excle.png')">
              <img v-else-if="type.standardData.indexOf('pptx')>-1"
                    class="label-preview"
                    :src="require('../../assets/image/images/icons/icon_file_ppt.png')">
              <img v-else-if="type.standardData.indexOf('docx')>-1"
                    class="label-preview"
                    :src="require('../../assets/image/images/icons/icon_file_word.png')">
              <img v-else-if="type.standardData.indexOf('txt')>-1"
                    class="label-preview"
                    :src="require('../../assets/image/images/icons/icon_file_txt.png')">
              <ZImage v-else
                      :value="type.standardData"
                      :error-src="require('../../assets/image/images/default_media.png')" />
            </div>
            <div style="margin-left:10px">
              <span>{{type.ssoFileName?type.ssoFileName:type.standardData}}</span>
            </div>
          </a>
        </span>
      </li>
    </ul>
</template>
<script>
import Bus from '../../bus.js'
export default {
  name:'txtContent',
  components:{
    Bus
  },
  props:{
    sortTag:Array
  },
  mounted(){
    var _this = this;
    if(_this.sortTag[0] instanceof Array){
      _this.sortTags = _this.sortTag[0]
    }else{
      _this.sortTags = _this.sortTag
    }
  },
  data(){
    return{
      sortTags:[]
    }
  },
  methods:{
    isPic (url) {
      if (url && typeof (url) == 'string' && url.indexOf('.png') > 0 || url && typeof (url) == 'string' && url.indexOf('.jpg') > 0) {
        return true;
      }
      return false;
    },
    //是否为视频文件
    isVideo (val) {
      var ty = false;
      if (val && val.indexOf('.mp4') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.flv') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.rmvb') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.wmv') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.avi') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.mov') > 0) {
        ty = true;
      }
      if (val && val.indexOf('.rm') > 0) {
        ty = true;
      }
      return ty;
    },
    caozuoFunc (link, type) {
      if (type == 'file') {
        var links = `https://${window.location.host}/cme-sso-app/space/transform?id=` + link.split('/')[link.split('/').length - 1].split('.')[0];
        this.$emit('sendType',{'link':links,'type':type});
      } else{
        this.$emit('sendType',{'link':link,'type':type});
      }
    }
  }
}
</script>
<style scoped>
  .txtContent{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color:#fff;
  }
  .txtContent li{
    display: block;
    width: 90%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    padding:0 5%;
  }
  .txtContent li.fill{
    height: auto;
  }
  .txtContent a.upload-pic{
    display: block;
    /* height: 36px; */
    line-height: 36px;
  }
  .txtContent a.upload-pic img{
    vertical-align: middle;
    height: 24px;
    object-fit: contain;
  }
  .txtContent a.upload-pic video {
  height: 24px;
  margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/txtContent.vue